<template>
  <div style="background-color: #edf4fc;">
    <div style="overflow: hidden;">
      <div>
        <div style="padding: 0.1rem;">
          <div class="news" style="text-align: center;margin-top: 0;">中国研究生入学考试</div>
          <p class="science-press-p">中国研究生入学考试是在中国进入研究生学习必须进行的考试，类似于进入大学阶段的高考。参加研究生考试的人员必须符合教育部《研究生入学考试招生简章》的相关规定，其中最重要的标准是对学历的要求。</p>
          <p class="science-press-p">
            中国研究生入学考试包括
            <a href="#one" class="divcolor">
              <span style="font-size: 18px;"> 初试 </span>
            </a>
            和
            <a href="#two" class="divcolor">
              <span style="font-size: 18px;"> 复试 </span>
            </a>
            。
          </p>
        </div>
        <div id="one" style="padding: 0.05rem;">
          <div class="news" style="text-align: center;margin-top: 0;">初试</div>
          <el-tabs v-model="activeName" style="margin-left: 0.1rem;">
            <el-tab-pane label="初试内容" name="first">
              <p class="science-press-p">初试，通常于1月的第二个周末，考试时间通常为两天。初试考试科目包含政治、外语（报名时自选）、数学（专业业务课一）、专业业务（专业业务课二）。考试方式均为笔试，四门课程共500分。</p>
              <p class="science-press-p">1、周六上午8:30-11:30：</p>
              <p class="science-press-p">2、统一考试、法律硕士联考及单考科目考政治理论(满分为100分)。</p>
              <p class="science-press-p">3、工商管理硕士专业学位(MBA)初试联考科目考综合能力(满分为200分)。</p>
              <p class="science-press-p">4、周六下午14:00-17:00：外国语（满分为100分）；</p>
              <p class="science-press-p">5、应试的外国语语种按招生单位的规定任选一种。</p>
              <p class="science-press-p">6、周日上午8:30-11:30：统考数学或专业基础课（满分各为150分）。</p>
              <p class="science-press-p">7、报考教育学、历史学、医学门类者，考专业基础综合（满分为300分）。</p>
              <p class="science-press-p">8、报考农学门类者，考农学门类公共基础。</p>
              <p class="science-press-p">9、报考理工财经类者，考统一数学，但根据专业要求不同，分数学一至数学四，共四等。</p>
              <p class="science-press-p">10、周日下午14:00-17:00：业务课（满分为150分）。</p>
              <p class="science-press-p">11、报考农学门类者，考农学学科基础综合。</p>
              <p class="science-press-p">12、其中，政治、外语、数学三门由教育部统一命题，专业业务由招生单位命题。</p>
            </el-tab-pane>
            <el-tab-pane label="报名材料准备" name="second">
              <p class="science-press-p">1、电子照片</p>
              <p class="science-press-p">2、有效身份证人像面和国徽面以及本人手持身份证照片</p>
              <p class="science-press-p">3、学生证（应届生）</p>
              <p class="science-press-p">4、毕业证学位证（往届生）</p>
              <p class="science-press-p">5、工作所在地报考的往届生：毕业证书照片、工作证明、社保缴纳记录或社保卡或居住证</p>
              <p class="science-press-p">6、学信网账号</p>
              <p class="science-press-p">7、档案所在地信息</p>
            </el-tab-pane>
            <el-tab-pane label="报名流程" name="third">
              <p class="science-press-p">1、登录研招网</p>
              <p class="science-press-p">2、点击统考报名</p>
              <p class="science-press-p">3、有学信网用学信网账号登录，没有的需要先注册</p>
              <p class="science-press-p">4、点网上报名</p>
              <p class="science-press-p">5、阅读报名须知</p>
              <p class="science-press-p">6、填写考生信息</p>
              <p class="science-press-p">7、填写报名基本信息</p>
              <p class="science-press-p">8、填写报考科目、报考考点，确认报考信息，牢记报名号</p>
              <p class="science-press-p">9、缴费</p>
              <br>
              <div style="text-align: center;margin-top: 0;font-size: 20px;">报考流程图</div>
              <img src="@/assets/process.jpg" alt="报考流程图" style="width: 100%;height: 8rem;" />
            </el-tab-pane>
            <el-tab-pane label="报考要求" name="fourth">
              <p class="science-press-p">1、国家承认学历的应届本科毕业生；</p>
              <p class="science-press-p">2、具有国家承认的大学本科毕业学历的人员；</p>
              <p class="science-press-p">3、获得国家承认的大专毕业学历后经两年或两年以上（从大专毕业到录取为硕士生当年9月1日），达到与大学本科毕业生同等学力，且符合招生单位根据本单位的培养目标对考生提出的具体业务要求的人员；国家承认学历的本科结业生和成人高校应届本科毕业生，按本科毕业同等学力身份报考；</p>
              <p class="science-press-p">4、已获硕士学位或博士学位的人员，可以再次报考硕士生，但只能报考委托培养或自筹经费的硕士生；</p>
              <p class="science-press-p">5、报考的年龄一般不超过40周岁，报考委托培养和自筹经费的考生年龄不限。</p>
              <p class="science-press-p">6、《2009年招收攻读硕士学位研究生管理规定》考生报名时应签署《考生诚信考试承诺书》，并规定建立全国统一考试考生诚信档案，作弊者下一年度不允许报考。</p>
              <p class="science-press-p">7、身体健康状况符合国家和招生单位规定的体检要求。</p>
            </el-tab-pane>
            <el-tab-pane label="报名时间" name="five">
              <p class="science-press-p">中国研究生招生信息网为研究生统一招生考试报名的唯一官方网站。一般9月中旬开放应届本科生预报名，10月中下旬开放正式报名，两个阶段只需一次报名，报名信息都有效。报名时间为开放日每日9：00—22：00，此时段外，不可以修改报名信息，且逾期不予办理。报名时不清楚之处应事先与招生单位联系。建议公网用户登录；教育网用户登陆。注册用户直接与报名号对应，每个账号只能报名一次。该账号是查询报名号的唯一方法，在后期的调剂系统中可继续使用。</p>
            </el-tab-pane>
            <el-tab-pane label="网上确认" name="six">
              <p class="science-press-p">全国硕士研究生招生考试报名包括网上报名和网上确认两个阶段。所有考生均须在规定时间内参加网上报名和网上确认，逾期不再补办。确认期间报考点将在网上集中审核考生上传的材料并通过系统向考生反馈审核结果，请务必仔细阅读所选报考点发布的网上确认公告，了解相关信息后再进行操作。考生网上确认报名信息上传材料开始和结束的具体时间以报考点发布的公告为准。所有报名缴费成功的考生均须按照所选报考点要求进行报名信息网上确认，未在网上报名阶段完成缴纳初试费的考生不予确认，未在规定的时间内进行网上确认报名信息或因自身原因未被通过审核的考生，其报名信息无效。</p>
              <p class="science-press-p">请考生特别注意：</p>
              <p class="science-press-p">1、网上确认期间我市各报考点均提供咨询服务,受理考生咨询。具体咨询方式请查阅北京教育考试院官网或所选报考点发布的公告信息。报考点在网上确认期间将发布有关提醒信息，请务必关注并及时查看。</p>
              <p class="science-press-p">2、考生网上确认时应当积极配合报考点工作人员，根据核验工作需要，按要求提交本人材料，由报考点工作人员进行核对。</p>
              <p class="science-press-p">3、未进行网上确认或网上确认未通过审核的考生，报名信息无效，其初试费将由研招网信息平台在数据核查结束后(预计在12月底前)退回原支付账户。为确保退费顺利进行，在此特别提醒：考生不要急于注销支付账户，发现问题请及时与研招网客服联系。</p>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <el-row>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">初试内容</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data1" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage1" :page-size="pageSize" background layout="prev, pager, next" :total="total1" @current-change="handleCurrentChange1" />
              </div>
            </el-col>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">初试报名流程</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data2" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage2" :page-size="pageSize" background layout="prev, pager, next" :total="total2" @current-change="handleCurrentChange2" />
              </div>
            </el-col>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">初试报名时间及要求</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data3" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage3" :page-size="pageSize" background layout="prev, pager, next" :total="total3" @current-change="handleCurrentChange3" />
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="two" style="padding: 0.05rem;">
          <div class="news" style="text-align: center;margin-top: 0;">复试</div>
          <div style="margin-left: 0.1rem;">
            <p class="science-press-p">研究生复试是研究生考试制度的重要组成部分，即通过研究生入学考试（初试）后参加的，由报考院校组织进行的第二次考试。一般也分笔试和面试。早期的研究生复试多只是一种形式，但从2006年起研究生招生加大了复试的权重，有的招生单位甚至把复试的权重加大为百分之五十，这就要求考生具有真才实学并具备更高的应变能力。</p>
            <p class="science-press-p">各个高校考研复试成绩计算方法略有不同，一般来说大多数高校的计算方法如下：</p>
            <p class="science-press-p">复试成绩 = 专业课笔试成绩×笔试权重+面试成绩×（90%-笔试权重）+外语听说能力成绩×10%</p>
          </div>
          <el-tabs v-model="activeName" style="margin: 0.1rem;">
            <el-tab-pane label="复试流程" name="first">
              <p class="science-press-p">1、判断是否达到国家线标准，与去年的国家线相差不大的考生可以提前做好准备。</p>
              <p class="science-press-p">2、每天浏览各个网站，收集调剂信息、一旦遇到适合自己的调剂信息，立即记录下来，然后查找并了解相关学校。</p>
              <p class="science-press-p">3、判断是否达到调剂院校的分数线。根据第2步收集到的调剂信息，看自己的分数是否能够达到调剂院校的分数线。如果能够达到，那就可以申请调剂了。虽然各个院校的分数线尚未公布，但可以参考去年的分数线作为参考。</p>
              <p class="science-press-p">4、与调剂院校取得联系。如果你认为自己的分数接近调剂院校的录取线，那么请尽快与他们取得联系。给导师发一封邮件，同时附上个人简历和作品集（如有），还可以考虑联系几所其他学校。</p>
              <p class="science-press-p">5、查看导师的回复。如果调剂院校的导师给你回信，并确认愿意接受你，最好还能索要导师的联系方式，以便进行进一步的沟通。</p>
              <p class="science-press-p">6、国家录取线公布。一旦国家录取线公布，确认自己已经达到该线，证明自己可以参与调剂，这时候大家都开始准备了。你要更加努力，收集更多有关调剂的信息，并继续与导师保持联系。</p>
              <p class="science-press-p">7、院校校线公布。你可以确认是否有机会调剂到之前联系过的学校。如果是的话，可以再次给导师发邮件表示愿意参与该校的调剂，并希望能够继续与导师保持联系。如果未能成功，也可以发邮件向导师表达感谢之情。同时，在接下来的日子里会有更多关于调剂的信息发布，你可以尝试寻找其他可以调剂的学校。</p>
              <p class="science-press-p">8、确定你的目标调剂院校。从几个确定的目标调剂院校中选择你最喜欢的那个。</p>
              <p class="science-press-p">9、开放调剂系统。中国研究生招生信息网上的调剂系统已经开放，你可以进去报名之前已经沟通好的调剂院校。你可以同时报名三所学校，在报名后会进行12-48小时的锁定。</p>
              <p class="science-press-p">10、目标院校同意。在研招网上，目标院校已经批准你参加复试，现在你只需要好好准备复试了。</p>
              <p class="science-press-p">11、准备调剂院校复试。根据调剂院校的复试规则，一般包括笔试和面试。笔试是专业课的笔试，面试包括专业课面试和英语面试。有些学校可能没有笔试，但基本都会有面试。</p>
              <p class="science-press-p">12、参加复试。你已经提前联系好了调剂院校，参加复试的方式可能是线上或线下。按照事先安排好的步骤进行，只要不出现大的问题，肯定会被录取。</p>
              <p class="science-press-p">13、拟录取公示。在拟录取名单公示期间，请再次确认自己是否真的被录取。确认录取后，向导师发送信息，告知他们好消息，并感谢导师的支持。</p>
              <p class="science-press-p">14、接受录取通知书。</p>
              <p class="science-press-p">15、研究生入学报道。</p>
            </el-tab-pane>
            <el-tab-pane label="复试内容" name="second">
              <p class="science-press-p">1、自我介绍：在考研复试中，考生需要进行自我介绍，介绍自己的基本情况、研究方向、兴趣爱好等信息，并突出自己的特长和优势。</p>
              <p class="science-press-p">2、英语口语：英语口语是考研复试中的重要环节之一。考生需要准备一份英语自我介绍，并能够自如地用英语进行交流。</p>
              <p class="science-press-p">3、学科基础知识测试：学科基础知识测试是考研复试中的重要环节之一。考生需要复习和加强自己所学专业的基础知识，并了解相关学科领域的前沿研究动态和热点问题。</p>
              <p class="science-press-p">4、综合素质面试：综合素质面试是考研复试中的重要环节之一，也是考生最需要关注的环节之一。在面试过程中，考官将从考生的思维能力、分析能力、表达能力、组织协调能力、沟通能力、创新能力等方面考察考生的综合素质和能力。</p>
              <p class="science-press-p">5、试讲环节：试讲环节是考研复试中的重要环节之一。考生需要准备一份有针对性、有趣味性的试讲稿，并根据试讲的要求和评分标准，进行反复练习和调整。</p>
            </el-tab-pane>
            <el-tab-pane label="面试技巧" name="third">
              <p class="science-press-p">1、自信从容：在面试过程中，考生需要表现出自信和从容，让考官感觉到自己具有一定的实力和能力。同时，考生也需要注意言行举止，不要过于紧张或放松，以免给考官留下不好的印象。</p>
              <p class="science-press-p">2、礼貌谦虚：在面试过程中，考生需要表现出礼貌和谦虚的态度，尊重考官的意见和建议。同时，考生也需要注意自己的语言和行为，不要使用过于生硬或不恰当的用语，以免给考官留下不好的印象。</p>
              <p class="science-press-p">3、逻辑清晰：在面试过程中，考生需要表现出逻辑清晰、思路明确的能力，能够准确地回答考官提出的问题，并且把握住问题的重点。</p>
              <p class="science-press-p">4、积极互动：在面试过程中，考生需要积极与考官互动，回答问题时要注意表达清晰、简明，同时可以适当地加入自己的看法和思考，与考官进行良好的交流。</p>
              <p class="science-press-p">5、合理分配时间：在面试过程中，考生需要合理地分配时间，避免浪费时间或紧张过度，以确保每个环节都能充分地发挥自己的优势和能力。</p>
            </el-tab-pane>
            <el-tab-pane label="注意事项" name="fourth">
              <p class="science-press-p">1、提前准备：在考研复试前，考生需要提前准备，了解复试的流程和考试要求，并做好相应的准备工作，以确保自己的状态和能力达到最佳状态。</p>
              <p class="science-press-p">2、重视学科基础知识：学科基础知识是考研复试中的重要环节之一，考生需要充分准备并提高自己的学科理论水平和解决问题的能力，以便在复试中发挥出自己的优势。</p>
              <p class="science-press-p">3、突出个人优势：在面试过程中，考生需要突出自己的个人优势和特长，展示自己的综合素质和能力，以便在复试中获得更好的成绩。</p>
              <p class="science-press-p">4、注意形象和仪表：在复试过程中，考生需要注意自己的形象和仪表，保持整洁干净、得体合适的穿着和发型，以便给考官留下良好的印象。</p>
              <p class="science-press-p">5、注意语言和行为：在面试过程中，考生需要注意自己的语言和行为，尽可能地避免使用不恰当的用语和行为，以免给考官留下不好的印象。</p>
            </el-tab-pane>
            <el-tab-pane label="复试问答" name="five">
              <p class="science-press-p">1. 复试面试中到底考察我们哪方面的能力呢?</p>
              <p class="science-press-p">复试面试过程中其实主要考察考生的综合素质。包括考生本科期间的能力结构、知识结构、计算机操作能力、外语能力和应变能力，在回答问题的时候并不要求十分精准的答案，但是要求考生流畅清楚以及有逻辑性的陈述即可。</p>
              <p class="science-press-p">2. 复试面试中我应该怎样表现呢?</p>
              <p class="science-press-p">复试中首先要态度端正，不要表现出一副无所谓或者满不在乎的样子，同时要控制好回答问题的时间。</p>
              <p class="science-press-p">3. 复试面试中的问题是不是都特别难?</p>
              <p class="science-press-p">考生其实不必过于紧张，撇开学术问题，导师或许营造轻松对话氛围，让学生放松下来，就爱好，兴趣等等畅所欲言，学生也大可不必紧张，时刻提防，只要口气自然自信沉着即可，过分城府和老道反而适得其反。最后，考研复试本质上是一场面试活动，一场人与人之间的会面交流，作为学生一方，要着装得体，言谈温雅，谦虚诚恳，甚至注意手机调至振动等等细节，这些实属交往所尚之礼节，无须赘述。</p>
              <p class="science-press-p">4. 要不要提前到复试院校地点?</p>
              <p class="science-press-p">至少保证提前一天到。第一，熟悉考场环境。第二，可以看点书准备复试。</p>
              <p class="science-press-p">5. 面试一般会有几个老师?</p>
              <p class="science-press-p">通常来说大约在五位到八位之间。但有的学校可能只有三个，有的学校却有十个。</p>
              <p class="science-press-p">6. 复试面试的时候我究竟应该怎样着装?</p>
              <p class="science-press-p">不管你穿什么衣服，都应该做到整洁、得体、大方、朴素，关键是自己觉得自在。如果你平时没有穿西服，复试时候穿西服，你自己本身就不自在。如果是应届考生，建议保留“学生样”，工作了的，就应该有“工作过的样子”，男生最好不要留长发，除非是搞艺术类的。女生不要穿吊带，高跟鞋，耳环、首饰，千万不能涂指甲。</p>
              <p class="science-press-p">7. 进入复试考场前会很紧张，怎么办?</p>
              <p class="science-press-p">很正常的反应。建议没有轮到自己复试之前，不要和其他的考生朋友谈论关于复试的事，只会更加紧张，可以在离复试不远的地方看看所带的复试资料，或者听点音乐，进去后你就很快会消除紧张感。</p>
              <p class="science-press-p">8. 进入面试考场时怎么做?</p>
              <p class="science-press-p">如果没有秘书带领，一定要轻轻敲门，待应允后再进去，进去后，一定要向在座的所有考官(导师)进行问好，如“各位老师好”、“下午好”等等，进行行礼，然后坐下。</p>
              <p class="science-press-p">9. 分数线出来了，我却更担忧了，该怎么办?</p>
              <p class="science-press-p">能解决的问题不用担心，不能解决的问题担忧也没有用。别人能解决的问题，如果你不能，那就是你个人问题，所以一定要在复试前做好心态调整工作。</p>
              <p class="science-press-p">10. 还没有最终确定复试学校，该怎么复习?</p>
              <p class="science-press-p">调剂成功前，先看原来报考学校的参考书目，确定后赶快看调剂学校的复试，看看有什么参考书目，再做新的计划。</p>
              <p class="science-press-p">11. 在复试阶段的考生都是什么心态呢?</p>
              <p class="science-press-p">在复试阶段，很多考生都会“瞻前顾后”。“瞻前”就是对过去的事情(如初试)进行评价，过分地关注。比如有的考生初试成绩很好，但他认为那是因为运气好、发挥好，因此对复试的信心和把握不大;有的考生初试成绩不好，排名靠后，于是就反省自己，自责当初应该如何努力、如何复习，整个人被自责的情绪控制。所谓“顾后”就是对将来还未发生的事情过分担忧。很多通过初试的考生，特别是分数并不是很高的考生，在复试的过程中会更加紧张和焦虑，担心诸如“复试是不是也能取得好成绩?”、“能不能争取到公费指标?”、“会不会优先考虑本校学生?”、“自己想报考的导师是不是愿意招自己?”等问题。</p>
            </el-tab-pane>
            <el-tab-pane label="研究生分类" name="six">
              <p class="science-press-p">1、按学籍管理</p>
              <p class="science-press-p">按学籍管理的不同，分为学历教育研究生和非学历教育研究生。前者指参加国家统一组织的入学考试（含应届本科毕业生的推荐免试和部分高等学校经教育部批准自行组织的单独入学考试），被录取后，获得研究生学籍。毕业时，若课程学习和论文答辩均符合学位条例的规定，可获硕士生毕业证书和硕士学位证书。后者指不参加国家统一组织的入学考试，没有学籍。学生参加研究生课程研修班学习，按教学计划修完课程，并通过国家统一组织的同等学历人员申请硕士学位外语水平和学科综合水平全国统一考试，获得申请学位的资格，再通过硕士论文答辩，可以获得学位证书，但没有研究生毕业证书。</p>
              <p class="science-press-p">2、按培养单位</p>
              <p class="science-press-p">我国研究生培养单位主要包括三类：</p>
              <p class="science-press-p">一、高等院校，如清华大学，复旦大学等；</p>
              <p class="science-press-p">二、科研院所，如中国科学院金属研究所等；</p>
              <p class="science-press-p">三、企业，如北京有色金属研究总院。</p>
              <p class="science-press-p">充分利用企业的资源培养研究生是我国高等教育的特色之一。</p>
              <p class="science-press-p">3、按专业用途</p>
              <p class="science-press-p">按照专业和用途的不同，分为学术型硕士研究生和专业型硕士研究生。</p>
              <p class="science-press-p">我国学术型学位按招生学科门类分为哲学、经济学、法学、教育学、文学、历史学、理学、工学、农学、医学、军事学、管理学，艺术学13大类，13大类下面再分为88个一级学科，88个一级学科下面再细分为300多个二级学科，同时还有招生单位自行设立的760多个二级学科。普通硕士的招生考试主要是年初的全国硕士研究生统一入学考试（简称”统考”），可获毕业证书和学位证书。</p>
              <p class="science-press-p">专业硕士对大家来说或许很陌生，但说到MBA、MPA却是耳熟能详。其实，MBA、MPA正是专业学位中的两种类别。我国经批准设置的专业硕士已达15类。</p>
              <p class="science-press-p">主要包括：工商管理硕士专业学位(MBA)、公共管理硕士专业学位(MPA)、工程硕士（ME）、法律硕士(J.M)、会计硕士专业学位(MPACC)、公共卫生硕士专业学位(MPH)、农业推广硕士专业学位、兽医硕士专业学位、教育硕士专业学位等。09年初，又新增了艺术硕士、体育硕士、风景园林硕士3个专业学位。专业硕士是我国研究生教育的一种形式。根据国务院学位委员会的定位，专业学位为具有职业背景的学位，培养特定职业高层次专门人才。专业硕士教育的学习方式比较灵活，大致可分为在职攻读和全日制学习两类。比较简单的区分办法是：招收在职人员、以业余时间学习为主的专业学位考试通常在每年的10月份进行，名为“在职人员攻读硕士学位全国联考”，简称“联考”，毕业后学历依然是“本科”，但是有专业学位证，也就是“单证”；招收全日制学生的专业学位硕士在每年年初举行的“全国硕士研究生统一入学考试”(简称“统考”)中举行，毕业后学历是“研究生”，领取专业学位证，也就是“双证”，全日制专业硕士是学历教育，GCT在职硕士不是学历教育，两者不能混为一谈。</p>
              <p class="science-press-p">4、按学习方法</p>
              <p class="science-press-p">按学习方法不同，分为全日制研究生（又称统招研究生）和在职研究生。前者指在高等学校和科研机构进行全日制学习的研究生；后者指在学习期间仍在原工作岗位承担一定工作任务的研究生。</p>
              <p class="science-press-p">5、按经费渠道</p>
              <p class="science-press-p">按学习经费渠道不同，分为国家计划研究生、委托培养研究生（简称委培生 ）和自费研究生。国家计划研究生的培养经费由国家提供，又分为非定向研究生和定向研究生（简称定向生）。其中非定向研究生毕业时实行双向选择的自由就业制度；定向生则在录取时就必须签订合同，毕业后按合同规定到定向地区或单位工作。委托培养研究生的培养经费由委托单位提供，录取时要签订合同，毕业后到委托单位工作。自费研究生的培养经费由自己提供，有时候也可以从导师科研经费中开支，或获取社会赞助。国家计划非定向研究生，通常就是我们所说的 " 公费 " 研究生，在硕士研究生招生名额中占据较大份额，但随着连年扩招，自费研究生的名额也在不断扩大。</p>
              <p class="science-press-p">2013年2月6日召开的国务院常务会议确定：从2014年秋季学期起，向所有纳入国家招生计划的新入学研究生收取学费，取消公费研究生计划。</p>
              <p class="science-press-p">自2014年考研起，各大高校将正式施行自费制度，即自2014年秋季学期起将向所有纳入全国研究生招生计划的考研新生收缴读研费用，但基本原则是“新生新规定、老生老制度”，也就是说2014年考研开始实施的收费制度并不会影响到2014年秋季学期前所招收的研究生则仍按原来的制度执行之前的收费政策，公费的仍然施行公费政策。</p>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <el-row>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">复试内容</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data4" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage4" :page-size="pageSize" background layout="prev, pager, next" :total="total4" @current-change="handleCurrentChange4" />
              </div>
            </el-col>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">复试流程</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data5" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage5" :page-size="pageSize" background layout="prev, pager, next" :total="total5" @current-change="handleCurrentChange5" />
              </div>
            </el-col>
            <el-col :span="8">
              <div style="border: 1px dashed gray;padding: 5px;border-radius: 5px;height: 3.25rem;margin: 0.2rem;">
                <div class="news" style="text-align: center;margin-left: 0;margin-right: 0;">面试技巧</div>
                <div style="height: 2.4rem;">
                  <div v-for="item in data6" :key="item.id" class="divcolor">
                    <a :href="item.link" class="cell-link" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
                <el-pagination :pager-count="5" :current-page="currentPage6" :page-size="pageSize" background layout="prev, pager, next" :total="total6" @current-change="handleCurrentChange6" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { SelectSign } from '@/api/signAPI'

export default {
  name: 'Sign',
  data() {
    return {
      activeName: 'first',
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1,
      currentPage4: 1,
      currentPage5: 1,
      currentPage6: 1,
      pageSize: 6,
      total1: 1,
      total2: 1,
      total3: 1,
      total4: 1,
      total5: 1,
      total6: 1
    }
  },
  created() {
    this.dataFind1()
    this.dataFind2()
    this.dataFind3()
    this.dataFind4()
    this.dataFind5()
    this.dataFind6()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async dataFind1() {
      const { data: res } = await SelectSign('初试内容', this.currentPage1, 6)
      this.data1 = res.data[2]
      this.total1 = res.data[0]
    },
    async dataFind2() {
      const { data: res } = await SelectSign('初试报名流程', this.currentPage2, 6)
      this.data2 = res.data[2]
      this.total2 = res.data[0]
    },
    async dataFind3() {
      const { data: res } = await SelectSign('初试报名时间及要求', this.currentPage3, 6)
      this.data3 = res.data[2]
      this.total3 = res.data[0]
    },
    async dataFind4() {
      const { data: res } = await SelectSign('复试内容', this.currentPage4, 6)
      this.data4 = res.data[2]
      this.total4 = res.data[0]
    },
    async dataFind5() {
      const { data: res } = await SelectSign('复试流程', this.currentPage5, 6)
      this.data5 = res.data[2]
      this.total5 = res.data[0]
    },
    async dataFind6() {
      const { data: res } = await SelectSign('面试技巧', this.currentPage6, 6)
      this.data6 = res.data[2]
      this.total6 = res.data[0]
    },
    async handleCurrentChange1(val) {
      this.currentPage1 = val
      const { data: res } = await SelectSign('初试内容', this.currentPage1, 6)
      this.data1 = res.data[2]
      this.total1 = res.data[0]
    },
    async handleCurrentChange2(val) {
      this.currentPage2 = val
      const { data: res } = await SelectSign('初试报名流程', this.currentPage2, 6)
      this.data2 = res.data[2]
      this.total2 = res.data[0]
    },
    async handleCurrentChange3(val) {
      this.currentPage3 = val
      const { data: res } = await SelectSign('初试报名时间及要求', this.currentPage3, 6)
      this.data3 = res.data[2]
      this.total3 = res.data[0]
    },
    async handleCurrentChange4(val) {
      this.currentPage4 = val
      const { data: res } = await SelectSign('复试内容', this.currentPage4, 6)
      this.data4 = res.data[2]
      this.total4 = res.data[0]
    },
    async handleCurrentChange5(val) {
      this.currentPage5 = val
      const { data: res } = await SelectSign('复试流程', this.currentPage5, 6)
      this.data5 = res.data[2]
      this.total5 = res.data[0]
    },
    async handleCurrentChange6(val) {
      this.currentPage6 = val
      const { data: res } = await SelectSign('面试技巧', this.currentPage6, 6)
      this.data6 = res.data[2]
      this.total6 = res.data[0]
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.divcolor {
  font-size: 25px;
}
.divcolor:hover {
  background-color: #B8860B;
}
.label-col {
  height: 40px;
  color: #fff;
  background-color: #3a2b05;
  font-size: 30px;
  padding: 10px;
  margin: 10px;
  margin-left: 0;
  margin-right: 0;
  border-radius: 6px;
}
.label-col a:hover {
  background-color: #ffffff;
}
p {
  margin-block-start: 0.05rem;
  margin-block-end: 0.05rem;
}
.science-press-p {
  font-size: 20px;
  text-indent: 0.3rem;
  text-align:justify;
  line-height: 1.6;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.1rem;
  font-size: 25px;
  font-weight: 700;
}
.cell-link {
  display: inline-block;
  font-size: 19px;
  width: 100%;
  padding: 0.066rem 0 0.066rem 0.05rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .el-tabs__item {
  font-size: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 0.05rem;
}
</style>
